export const ERR_CODES = {
  Success: 0,

  ErrorNoMember: 1000,
  ErrorLogin: 1001,
  ErrorAccountLocked: 1002,
  ErrorMessageSentWithin3Min: 1003,
  ErrorWrongApprovalNumber: 1004,
  ErrorInputTimeout: 1005,
  ErrorApprovalExceeded: 1006,
  ErrorRequestNotFound: 1007,
  ErrorAlreadyMember: 1008,
  ErrorSystemCmd: 9000,

  ErrorContactCenter: 1060,
  ErrorNotSubscribed: 1061,
  SuccessRefundRegistered: 1062,
  ErrorServiceHistory: 1063,
  ErrorCancelConfirm: 1065,
  ErrorContactCenterService: 1066,

  ErrorAuthMsgNumber3Wrong: 1033,
} as const
